import React from 'react'
//TODO import Helmet from 'react-helmet'
import {graphql} from 'gatsby'
import Image from 'gatsby-image';
import Layout from '../components/Layout'
import {HTMLContent} from '../components/Content'
import {Post} from '../components/blog/StyledPost';

const BlogPostTemplate = ({
                                     content,
                                     date,
                                     title,
                                     image
                                 }) => {
    return (
        <Post>
            <Image fluid={image.childImageSharp.gatsbyImageData}/>
            <div>
                <h1>{title}</h1>
                <p>{date}</p>
                <HTMLContent content={content}/>
            </div>
        </Post>
    );
};

const BlogPost = ({data}) => {
    const {markdownRemark: post} = data;

    return (
        <Layout>
            <BlogPostTemplate
                content={post.html}
                contentComponent={HTMLContent}
                description={post.frontmatter.description}
                image={post.frontmatter.image}
                // helmet={
                //     <Helmet titleTemplate="%s | Blog">
                //         <title>{`${post.frontmatter.title}`}</title>
                //         <meta
                //             name="description"
                //             content={`${post.frontmatter.description}`}
                //         />
                //     </Helmet>
                // }
                date={post.frontmatter.date}
                title={post.frontmatter.title}
            />
        </Layout>
    )
};

export default BlogPost

export const pageQuery = graphql`
    query BlogPostByID($id: String!) {
        markdownRemark(id: { eq: $id }) {
            id
            html
            frontmatter {
                date(formatString: "MMMM DD, YYYY")
                title
                description
                image {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED)
                    }
                }
            }
        }
    }
`;
